import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["link"];
import "core-js/modules/es.string.link.js";
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { isDark } from 'utils/ui/colors';
var Wrapper = styled.span.withConfig({
  displayName: "Logo__Wrapper",
  componentId: "sc-16umae1-0"
})(["display:inline-block;height:100%;"]);
var Image = styled.img.attrs(function (p) {
  return {
    src: isDark(p.theme.background) ? p.theme.globals.logo.invertedUrl : p.theme.globals.logo.url
  };
}).withConfig({
  displayName: "Logo__Image",
  componentId: "sc-16umae1-1"
})(["position:relative;left:", ";top:", ";display:inline-block;width:", ";max-width:100%;height:100%;object-fit:contain;"], function (p) {
  return pxToRem(p.theme.globals.logo.offsetX);
}, function (p) {
  return pxToRem(p.theme.globals.logo.offsetY);
}, function (p) {
  return pxToRem(p.theme.globals.logo.width);
});
var Logo = function Logo(_ref) {
  var link = _ref.link,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (link) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      as: Link,
      to: link || '/'
    }, /*#__PURE__*/React.createElement(Image, otherProps));
  }
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, otherProps));
};
Logo.defaultProps = {
  alt: ''
};
export default Logo;